export const tokenKey = "tokenKey";
export const tokenRequest = "REQUESTING_CRM_SHARED_CREDENTIALS";
export const tokenSharing = "RESPONSE_CRM_CREDENTIALS_SHARING";
export const tokenFlush = "REQUESTING_CRM_CREDENTIALS_FLUSH";

export const keyEnter = "Enter";
export const eventStorage = "storage";
export const eventResize = "resize";
export const eventBeforeUnload = "beforeunload";
export const eventKeyPress = "keypress";
export const eventMessage = "message";

export const parseDateTimeFormat = "yyyy-MM-dd HH:mm:ss";
export const dateTimeFormat = "g";
export const dateFormat = "d";
export const dateFormatFixed = "dd.MM.yyyy";
export const timeFormat = "t";

export const dateWidth = "140px";
export const dateTimeWidth = "181px";
export const numericWidth = "181px";
export const timeWidth = "93px";

export const styleNumber = { maxWidth: "181px" };

export const emailValidation = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const openParameters = "openParameters";

export const tokenRefreshInterval = 5 * 60 * 1000; // 5 minutes
export const pingInterval = 60 * 1000; // 1 minute;
export const maxAllowedDate = new Date(3000, 1, 1);

export function isMobileSize(w, h) { return w <= 680 || h <= 500; }

function getEditorSize(w) {
    return w < 400
        ? layoutSize.one
        : layoutSize.two;
}

export function getLayoutSize(w, actionExpanded) {
    const actualWidth = w - (actionExpanded ? 220 : 50) - 220 - 50;
    const minEditorWidth = 320;
    const labelWidth = 160;
    if (actualWidth < minEditorWidth + labelWidth)
        return { size: layoutSize.small, editor: layoutSize.one, inlineDialog: false };

    if (actualWidth < 2 * (minEditorWidth + labelWidth))
        return { size: layoutSize.one, editor: getEditorSize(actualWidth - labelWidth), inlineDialog: false };

    if (actualWidth < 3 * (minEditorWidth + 40 + labelWidth))
        return { size: layoutSize.two, editor: getEditorSize(actualWidth / 2 - labelWidth), inlineDialog: true };

    return { size: layoutSize.three, editor: getEditorSize(actualWidth / 3 - labelWidth), inlineDialog: true };
}

export function getContainerStyle(sizeMode) {
    var containerClass = "dm-container";
    if (!sizeMode)
        return containerClass;

    if (sizeMode.size === layoutSize.small)
        containerClass += " dm-container-slim";
    else if (sizeMode.size === layoutSize.two)
        containerClass += " dm-container-two";
    else if (sizeMode.size === layoutSize.three)
        containerClass += " dm-container-three";

    if (sizeMode.editor === layoutSize.two)
        containerClass += " dm-sizing-big";
    else
        containerClass += " dm-sizing-small";

    return containerClass;
}

export function getContainerEditorStyle(isBig) {
    var containerClass = "dm-container";
    if (isBig)
        containerClass += " dm-sizing-big";
    else
        containerClass += " dm-sizing-small";

    return containerClass;
}

export const authMode = {
    windowsAuth: 71,
    loginPassword: 72,
    undefined: 73,
    twoFactorAuthentication: 74
};

export function getFormatDateTime() {
    return {
        day: window.captions.FormatDay,
        month: window.captions.FormatMonth,
        year: window.captions.FormatYear,
        hour: "00",
        minute: "00"
    };
}

export function getFormatDate() {
    return { day: window.captions.FormatDay, month: window.captions.FormatMonth, year: window.captions.FormatYear };
}

export function getFormatTime() {
    return { hour: "00", minute: "00" };
}

export function getUiLanguages() {
    return [
        { name: window.captions.LanguageUkrainian, link: "ua", icon: "ua" },
        { name: window.captions.LanguageRussian, link: "ru", icon: "ru" },
        { name: window.captions.LanguageEnglish, link: "en", icon: "us" },
        { name: window.captions.LanguageBelarusian, link: "by", icon: "by" },
        { name: window.captions.LanguagePoland, link: "pl", icon: "pl" },
        { name: window.captions.LanguageGeorgia, link: "ge", icon: "ge" },
        { name: window.captions.LanguageVietnamese, link: "vn", icon: "vn" },
        { name: window.captions.LanguageEspanol, link: "es", icon: "es" },
        { name: window.captions.LanguageArabic, link: "ar", icon: "sa" }
    ];
}

export function getUiSources() {
    return [
        { id: 0, name: "ru" },
        { id: 1, name: "ua" },
        { id: 2, name: "en" },
        { id: 3, name: "by" },
        { id: 5, name: "pl" },
        { id: 6, name: "ge" },
        { id: 7, name: "vn" },
        { id: 8, name: "es" },
        { id: 10, name: "ar" }
    ];
}

export function getBooleanSources() {
    return [
        { value: 0, label: window.captions.WordNo },
        { value: 1, label: window.captions.WordYes },
        { value: 2, label: window.captions.Unseted }
    ];
}

export function getAdminBooleanSources() {
    return [
        { value: 0, label: window.captions.WordNo },
        { value: 1, label: window.captions.WordYes },
        { value: 3, label: window.captions.Unseted },
        { value: 2, label: window.captions.WordYesNo }
    ];
}

export function getCardFieldsSourceTypes() {
    return [
        { id: 0, name: window.captions.Field },
        { id: 1, name: window.captions.SpecialPaste },
        { id: 2, name: window.captions.SearchFields },
        { id: 3, name: window.captions.CalculatedFields },
        { id: 6, name: window.captions.Plugins }
    ];
}

export function getSoftPhoneTypes() {
    return [
        { value: softPhoneTypeEnum.notDefined, label: window.captions.NotDefinded },
        { value: softPhoneTypeEnum.pjPhone, label: window.captions.ExternalSoftPhone },
        { value: softPhoneTypeEnum.pjPhoneUdp, label: "PjPhone" },
        { value: softPhoneTypeEnum.pjPhoneCommand, label: "PjPhone (Command)" },
        { value: softPhoneTypeEnum.mediaTell, label: "PjPhone UDP" },
        { value: softPhoneTypeEnum.external, label: window.captions.MediaTell }
    ];
}

export function getStrategyEntity(source) {
    switch (source) {
        case entitySourcesNames.loan:
            return strategyEntity.loan;
        case entitySourcesNames.client:
            return strategyEntity.client;
        case entitySourcesNames.collateral:
            return strategyEntity.collateral;
        default:
            return undefined;
    }
}

export function promiseStateName(state) {
    switch (state) {
        case promiseState.kept:
            return window.captions.KeptPromise;
        case promiseState.broken:
            return window.captions.BrokenPromise;
        case promiseState.pending:
            return window.captions.PendingPromise;
        case promiseState.cancel:
            return window.captions.CancelPromise;
        case promiseState.partialPayment:
            return window.captions.PartialPayment;
        default:
            return "";
    }
}

export const exportMonitorState = {
    errorTemplateNotFound: 1,
    loadData: 2,
    prepareVariables: 3,
    readData: 4,
    receiveData: 5,
    errorUnknown: 6,
    loadingDataToFile: 7,
    errorNoData: 8
};

export const timeIntervalTypes = {
    Second: 0,
    Minute: 1,
    Hour: 2,
    Day: 3,
    Month: 4,
    Year: 5,
    Week: 6
};

export const exportTypes = {
    folder: 0,
    report: 1,
    reportSql: 2,
    document: 3,
    documentGroup: 4,
    reportSpecificModule: 5,
    documentClient: 6
};

export const notifyTypes = {
    notification: 0,
    chat: 1,
    card: 2,
    incomingCall: 3,
    cardRestriction: 4,
    userBlockChanged: 5,
    logout: 6,
    removeCard: 7,
    taskToClose: 8
};

export const chatTemplateTypes = {
    def: 0,
    image: 1,
    document: 3,
    post: 4,
    quote: 6
};

export const documentsParents = {
    loan: 0,
    creditor: 1,
    linkedPersons: 2,
    collaterals: 3,
    process: 4,
    processAction: 5,
    letter: 6,
    packages: 7,
    users: 8,
    project: 9,
    attachments: 10,
    task: 11
}

export const specialTypes = {
    fullHistory: -1,
    payments: -2,
    stageMovements: -3,
    documents: -4,
    process: -5,
    linkedData: -6,
    collaterals: -7,
    paymentPlan: -8,
    linkedClient: -9,
    callsRecords: -10,
    settedTasks: -11,
    historyEvents: -12,
    promiseScheduler: -13,
    specificModule: -14,
    processMovements: -15,
    documentPackages: -16,
    collateralOwners: -17,
    accounts: -18,
    collateralScheduler: -19,
    collateralQueue: -20,
    CollateralSchema: -21,
    loanChat: -22,
    loanAgreement: -23,
    separator: -100
};

export const fieldTypes = {
    text: 0,
    integer: 1,
    double: 2,
    date: 3,
    phone: 4,
    address: 5,
    passport: 6,
    boolean: 7,
    valueArray: 8,
    simpleDictionary: 9,
    extendedDictionary: 10,
    time: 11,
    edrvp: 12,
    dateTime: 13,
    timeZone: 14,
    email: 15,
    url: 16,
    multiSimpleDictionary: 17,
    multiExtendedDictionary: 18,
    image: 19,
    color: 20,
    account: 21
};

export const entitySources = {
    client: 0,
    loan: 1,
    collateral: 2,
    collateralAddons: 3,
    process: 4,
    processAction: 5,
    dictionary: 6,
    history: 7,
    historyEvent: 8,
    task: 9,
    project: 10,
    projectGroup: 57,
    payments: 11,
    users: 12,
    paymentPlan: 13,
    phone: 14,
    address: 15,
    email: 16,
    url: 17,
    promisePayment: 18,
    externalExecutor: 19,
    collateralOwner: 40,
    collateralLoan: 41,
    clientToLoans: 42,
    clientToClients: 62,
    constants: 43,
    historyField: 44,
    historyCurrency: 45,
    historyRegion: 46,
    historyClientType: 47,
    hClient: 48,
    hLoan: 49,
    hCollateral: 50,
    telephony: 52,
    queue: 53,
    strategyHistory: 54,
    smsHistory: 55,
    emailHistory: 56,
    documents: 58,
    userDocuments: 59,
    promiseScheduler: 60,
    autoAction: 61,
    specials: 80,
    documentPackages: 81,
    addressDirectory: 100,
    account: 102,
    accountLimit: 104,
    callRecords: 101,
    recordsRating: 103,
    collateralReserves: 105,
    historyExecutor: 106
};

export const strategyEntity = {
    loan: 0,
    phone: 1,
    client: 2,
    process: 3,
    processAction: 4,
    callRecords: 5,
    account: 6,
    accountLimit: 7,
    collateral: 8
};

export const filterFieldTypes = {
    text: 0,
    bool: 1,
    number: 2,
    date: 3,
    dropArray: 4,
    treeArray: 5,
    financial: 6,
    time: 7,
    intNumber: 8,
    dateTime: 9,
    address: 10,
    timeInterval: 11
};

export const filterSources = {
    loan: 0,
    client: 1,
    collateral: 3,
    callRecords: 4,
    documents: 5
};

export const entitySourcesNames = {
    client: "client",
    loan: "loan",
    collateral: "collateral",
    collateralAddons: "collateralAddons",
    callRecords: "callRecords",
    documents: "documents",
    questionnaire: "questionnaire",
    process: "process",
    processAction: "processAction",
    users: "users",
    payments: "payments",
    paymentPlan: "paymentPlan",
    project: "project",
    projectGroup: "projectGroup",
    phone: "phone",
    address: "address",
    email: "email",
    url: "url",
    promiseScheduler: "promiseScheduler",
    promisePayment: "promisePayment",
    specials: "specials",
    account: "account",
    accountLimit: "accountLimit",
    accountTransaction: "accountTransaction",
};

export const minBrowserVersions = {
    chrome: "42",
    edge: "14",
    firefox: "39",
    opera: "29",
    safari: "10.3"
};

export const promiseState = {
    kept: 0,
    broken: 1,
    pending: 2,
    cancel: 3,
    partialPayment: 4
};

export const paymentPeriods = {
    week: 0,
    month: 1,
    unknown: 2,
    day: 3
};

export const timeIntervalType = {
    second: 0,
    minute: 1,
    hour: 2,
    day: 3,
    month: 4,
    year: 5
};

export const callDirection = {
    incomingCall: 0,
    outgoingCallManual: 1,
    outgoingCallAutoDial: 2
};

export const callConditionDirection = {
    undefined: 0,
    incoming: 1,
    outgoing: 2
};

export const controlType = {
    window: 0,
    stackPanel: 1,
    grid: 2,
    field: 3,
    fieldsList: 4,
    button: 5,
    gridView: 6,
    textBlock: 7,
    hyperlink: 8,
    scrollViewer: 9,
    comboBox: 10,
    dateTimePicker: 11,
    browser: 12,
    tabControl: 13,
    tabItem: 14,
    chart: 15,
    map: 16
};

export const userFieldTypes = {
    text: 0,
    integer: 1,
    double: 2,
    date: 3,
    dateTime: 13,
    boolean: 7,
    simpleDictionary: 9,
    passport: 6,
    phone: 4,
    button: 91
};

export const entityType = {
    undefinded: 0,
    client: 1,
    loan: 2,
    collateral: 3,
    collateralAddons: 4,
    pocess: 5,
    processAction: 6,
    dictionary: 7,
    history: 8,
    historyField: 28,
    historyEvent: 9,
    task: 10,
    project: 11,
    payments: 12,
    users: 13,
    paymentPlan: 14,
    phone: 15,
    address: 16,
    email: 17,
    url: 18,
    promisePayment: 19,
    constants: 20,
    addressDirectory: 21,
    account: 22,
    accountLimit: 23,
    clientToLoans: 24,
    promiseScheduler: 25,
    historyExecutor: 26,
    documents: 27
}

export const taskStates = {
    unknown: -1,
    relevant: 0,
    notRelevant: 1,
    implemented: 2,
    overdue: 3,
    implementedOverdue: 4,
    overdueNotRelevant: 5
};

export const ignoreSaveHistoryList = ["Archived",
    "AID",
    "ExternalUserId",
    "State",
    "Stage",
    "Stage",
    "Region",
    "Currency"];

export const buttonType = {
    undefined: 0,
    add: 1,
    remove: 2,
    save: 3,
    refresh: 4,
    exportWord: 5,
    exportExcel: 6,
    openCard: 7,
    openSearch: 8
};

export const chartType = {
    funnel: 0,
    pie: 1,
    bar: 2,
    linear: 3
};

export const chartSeriesType = {
    line: 0,
    spline: 1,
    area: 2,
    splineArea: 3,
    stepLine: 4,
    stepArea: 5
};

export const layoutSize = {
    one: 1,
    small: 2,
    two: 3,
    three: 4
};

export const pluginRequestType = {
    execute: 0,
    getElements: 1,
    checkParameters: 2,
    saveParameters: 3,
    buttonClick: 4,
    openCard: 5
};

export const pickerInputMode = {
    datePicker: 0,
    dateTimePicker: 1,
    timePicker: 2
};

export const questionnaireGroupType = {
    fields: 0,
    documents: 1,
    linkedPersons: 2,
    accounts: 3
};

export const softPhoneTypeEnum = {
    notDefined: 0,
    pjPhone: 1,
    pjPhoneUdp: 6,
    pjPhoneCommand: 7,
    mediaTell: 3,
    external: 2
};

export const statGeneralTypeEnum = {
	folder: 0,
    report: 1,
    reportSql: 2,
    document: 3,
    documentGroup: 4,
	reportSpecificModule: 5
};

export const historyAttachmentTypes = {
    phone: -1,
    address: -2,
    email: -3,
    url: -4
};

export const exportFilterTypes = {
	customFields: -27,
	dateDocumentCreated: -26,
	dateEmailCreated : -25,
	dateSmsCreated : -24,
	datePromiseScheduler : -23,
	dateUserSchedule : -22,
	dateTelephonyResult: -21,
	dateProcessAction: -20,
	processType: -19,
	linkedPersonsType: -18,
	loanCollateralOwner: -17,
	collateralOwnerType: -16,
	collateralState: -15,
	collateralType: -14,
	taskExecutor: -13,
	contactAuthor: -12,
	dateTaskFinished: -11,
	dateTaskCreated: -10,
	datePayment: -9,
	dateDeclared: -8,
	datePromiss: -7,
	dateNextContact: -6,
	dateContact: -5,
	dateLoan: -4,
	executor: -3,
	state: -2,
	project: -1,
	actualDate: 0
};

export const varSourceType = {
    field: 0,
    history: 1,
    linkedPersons: 2,
    collaterals: 3,
    payments: 4,
    paymentPlan: 5,
    tasks: 6,
    other: 7,
    users: 8,
    project: 9,
    collateralsOwners: 10,
    process: 11,
    processAction: 12,
    telephony: 13,
    clientField: 14,
    loanField: 15,
    phone: 16,
    address: 17,
    email: 18,
    url: 19,
    promisePayment: 20,
    smsHistory: 21,
    emailHistory: 22,
    documents: 23,
    userDocuments: 24,
    callRecords: 25,
    recordsRating: 26,
    promiseScheduler: 27
};

export const varConvertCode = {
    none: 0,
    barcode: 1,
    qrCode: 2
}

export const varType = {
    dataView: 0,
    calculation: 1,
    sql: 2
}

export const varDataArrayType = {
    line: 0,
    table: 1,
    merge: 2,
    mergeWithHeaders: 3,
    singleLine: 4,
    mergedLine: 5
}

export const spellingGender = {
    male: 0,
    female: 1,
    neuter: 2,
    plural: 3,
    ordinalNominal: 4,
    ordinalGeneric: 5
}

export const varFormulaType = {
    none: 0,
    count: 1,
    first: 2,
    last: 3,
    min: 4,
    max: 5,
    sum: 6,
    avg: 7
}

export const varDateDivider = {
    none: 0,
    hour: 1,
    day: 2,
    week: 3,
    month: 4,
    year: 5
}

export const pdfVersion = {
    default: 0,
    version1_0: 1,
    version1_1: 2,
    version1_2: 3,
    version1_3: 4,
    version1_4: 5,
    version1_5: 6,
    version1_6: 7,
    version1_7: 8
}

export function baseFieldSourceToVarSourceType(source) {
    switch (source) {
        case entitySources.client:
            return varSourceType.clientField;
        case entitySources.loan:
            return varSourceType.loanField;
        case entitySources.collateral:
        case entitySources.collateralAddons:
            return varSourceType.collateral;
        case entitySources.process:
            return varSourceType.process;
        case entitySources.processAction:
            return varSourceType.processAction;
        case entitySources.history:
        case entitySources.historyEvent:
        case entitySources.historyField:
            return varSourceType.history;
        case entitySources.task:
            return varSourceType.task;
        case entitySources.project:
            return varSourceType.project;
        case entitySources.payments:
            return varSourceType.payments;
        case entitySources.users:
            return varSourceType.users;
        case entitySources.paymentPlan:
            return varSourceType.paymentPlan;
        case entitySources.phone:
            return varSourceType.phone;
        case entitySources.address:
            return varSourceType.address;
        case entitySources.email:
            return varSourceType.email;
        case entitySources.url:
            return varSourceType.url;
        case entitySources.promisePayment:
            return varSourceType.promisePayment;
        case entitySources.promiseScheduler:
            return varSourceType.promiseScheduler;
        case entitySources.collateralOwner:
            return varSourceType.collateralsOwners;
        case entitySources.clientToLoans:
        case entitySources.clientToClients:
            return varSourceType.linkedPersons;
        case entitySources.document:
            return varSourceType.documents;
        case entitySources.telephony:
            return varSourceType.telephony;
        case entitySources.smsHistory:
            return varSourceType.smsHistory;
        case entitySources.emailHistory:
            return varSourceType.emailHistory;
        case entitySources.specials:
            return varSourceType.specials;
        case entitySources.callRecords:
            return varSourceType.callRecords;
        case entitySources.recordsRating:
            return varSourceType.recordsRating;
        default:
            return varSourceType.field;
    }
}

export function isFieldDictionary(fieldType) {
    return fieldType === fieldTypes.simpleDictionary ||
        fieldType === fieldTypes.extendedDictionary ||
        fieldType === fieldTypes.multiSimpleDictionary ||
        fieldType === fieldTypes.multiExtendedDictionary ||
        fieldType === fieldTypes.valueArray ||
        fieldType === fieldTypes.timeZone;
}

export function getMoodsPath(name) {
    switch (name) {
        case moodsNames.moodSurprised:
            return "M16,20.632996C14.427002,20.632996 13.389,22.290009 13.18,22.933014 13.375999,23.206024 14.142002,23.813019 16,23.813019 17.867001,23.813019 18.641003,23.195007 18.824001,22.937012 18.632,22.309021 17.600002,20.632996 16,20.632996z M16,18.63501C19.09,18.63501 20.848,21.835022 20.848,22.984009 20.848,24.132996 19.423,25.811005 16,25.811005 12.577,25.811005 11.152,24.10202 11.152,22.984009 11.152,21.865997 12.91,18.63501 16,18.63501z M11.005001,7.2590027C12.382999,7.2579956 13.503002,8.9360046 13.503002,11.005005 13.503002,13.074005 12.382999,14.752014 11.005001,14.752014 9.6270027,14.752014 8.507,13.074005 8.507,11.005005 8.507,8.9360046 9.6270027,7.2579956 11.005001,7.2590027z M20.995003,7.2579956C22.373001,7.2579956 23.493004,8.9360046 23.493004,11.005005 23.493004,13.074005 22.373001,14.752014 20.995003,14.752014 19.617001,14.752014 18.498001,13.074005 18.498001,11.005005 18.498001,8.9360046 19.617001,7.2579956 20.995003,7.2579956z M16,2.4970093C8.5550003,2.4970093 2.4980011,8.5550232 2.4980011,16 2.4980011,23.445007 8.5550003,29.503021 16,29.503021 23.445,29.503021 29.502998,23.445007 29.502998,16 29.502998,8.5550232 23.445,2.4970093 16,2.4970093z M16,0C24.836998,0 32,7.1630249 32,16 32,24.837006 24.836998,32 16,32 7.163002,32 0,24.837006 0,16 0,7.1630249 7.163002,0 16,0z";
        case moodsNames.moodKiss:
            return "M17.599998,19.882996C19.428991,19.886993 19.745992,21.574005 22.142996,21.678009 19.032995,22.734009 18.631996,24.570007 15.999992,24.570007 13.36799,24.570007 12.743997,22.822998 9.8569897,21.571991 11.49499,21.173004 12.654001,19.925995 14.47799,19.921997 15.128991,19.921997 15.270989,20.809998 16.047996,20.809998 16.782997,20.809998 16.978996,19.882996 17.599998,19.882996z M18.938986,13.574005C19.658987,13.566986 21.225988,14.165985 22.243994,14.165985 23.600986,14.165985 25.933994,13.182007 25.933994,13.826996 25.933994,14.472992 23.600986,15.893005 22.243994,15.893005 20.886999,15.893005 18.552986,14.553009 18.552986,13.826996 18.552986,13.644989 18.698997,13.575989 18.938986,13.574005z M13.010996,13.574005C13.247995,13.575989 13.391001,13.644989 13.391001,13.826996 13.391001,14.553009 11.092997,15.893005 9.7559927,15.893005 8.4179953,15.893005 6.1209996,14.472992 6.1209996,13.826996 6.1209996,13.182007 8.4179953,14.165985 9.7559927,14.165985 10.758998,14.165985 12.301996,13.566986 13.010996,13.574005z M15.999992,2.4970093C8.5550039,2.4970093 2.4980002,8.5549927 2.4980002,16 2.4980002,23.445007 8.5550039,29.502991 15.999992,29.502991 23.444996,29.502991 29.502992,23.445007 29.502992,16 29.502992,8.5549927 23.444996,2.4970093 15.999992,2.4970093z M15.999992,0C24.836994,0 32,7.1629944 32,16 32,24.837006 24.836994,32 15.999992,32 7.1629913,32 1.9745858E-07,24.837006 0,16 1.9745858E-07,7.1629944 7.1629913,0 15.999992,0z";
        case moodsNames.moodSmile:
            return "M6.9509888,19.851013C9.5009766,21.684998 12.618958,22.778015 16,22.778015 19.380981,22.778015 22.498962,21.684998 25.04895,19.851013 23.046997,22.697021 19.743958,24.563019 16,24.563019 12.255981,24.563019 8.9530029,22.697021 6.9509888,19.851013z M20.994995,11.005005C22.372986,11.005005 23.492981,12.123016 23.492981,13.503021 23.492981,14.881012 22.372986,16 20.994995,16 19.617004,16 18.497986,14.881012 18.497986,13.503021 18.497986,12.123016 19.617004,11.005005 20.994995,11.005005z M11.005005,11.005005C12.382996,11.005005 13.501953,12.123016 13.501953,13.503021 13.501953,14.881012 12.382996,16 11.005005,16 9.6269531,16 8.506958,14.881012 8.506958,13.503021 8.506958,12.123016 9.6269531,11.005005 11.005005,11.005005z M16,2.4970093C8.5549927,2.4970093 2.4979858,8.5550232 2.4979858,16 2.4979858,23.445007 8.5549927,29.503021 16,29.503021 23.445007,29.503021 29.501953,23.445007 29.501953,16 29.501953,8.5550232 23.445007,2.4970093 16,2.4970093z M16,0C24.835999,0 32,7.1640015 32,16 32,24.835999 24.835999,32 16,32 7.1640015,32 0,24.835999 0,16 0,7.1640015 7.1640015,0 16,0z";
        case moodsNames.moodSleepy:
            return "M16,22.32901C18.282959,22.32901 19.58197,23.529022 19.58197,23.529022 19.58197,23.529022 18.531006,24.605011 16,24.605011 13.471008,24.605011 12.417969,23.529022 12.417969,23.529022 12.417969,23.529022 13.71698,22.32901 16,22.32901z M17.690002,16.071014C18.409973,16.063995 19.97699,16.662994 20.994995,16.662994 22.35199,16.662994 24.685974,15.679016 24.685974,16.324005 24.685974,16.971008 22.35199,18.390015 20.994995,18.390015 19.638,18.390015 17.304993,17.050995 17.304993,16.324005 17.304993,16.143005 17.449951,16.072998 17.690002,16.071014z M14.26001,16.071014C14.495972,16.072998 14.639954,16.143005 14.639954,16.324005 14.639954,17.050995 12.341003,18.390015 11.005005,18.390015 9.6679688,18.390015 7.3699951,16.971008 7.3699951,16.324005 7.3699951,15.679016 9.6679688,16.662994 11.005005,16.662994 12.006958,16.662994 13.550964,16.063995 14.26001,16.071014z M16,2.4970093C8.5549927,2.4970093 2.4970093,8.5550232 2.4970093,16 2.4970093,23.445007 8.5549927,29.503021 16,29.503021 23.445007,29.503021 29.502991,23.445007 29.502991,16 29.502991,8.5550232 23.445007,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1629944 32,16 32,24.837006 24.836975,32 16,32 7.1629639,32 0,24.837006 0,16 0,7.1629944 7.1629639,0 16,0z";
        case moodsNames.moodCry:
            return "M16,16.112C20.901001,16.112 23.388,19.994995 23.388,23.459999 23.388,23.459999 21.010986,22.215996 16,22.215996 10.988953,22.215996 8.6119995,23.459999 8.6119995,23.459999 8.6119995,19.994995 11.098999,16.112 16,16.112z M8.4289551,13.346001C8.4289551,13.346001 8.3319702,13.927002 8.3319702,16.331001 8.3319702,17.581001 7.5879517,18.371002 6.4779663,18.371002 5.3659668,18.371002 4.8609619,17.351997 4.8880005,16.408997 4.9469604,14.343002 8.4289551,13.346001 8.4289551,13.346001z M24.820007,12.098C24.820007,12.098 28.300964,13.094002 28.359985,15.158997 28.388,16.102997 27.882996,17.123001 26.770996,17.123001 25.66095,17.123001 24.916992,16.331001 24.916992,15.083 24.916992,12.678001 24.820007,12.098 24.820007,12.098z M20.994995,8.5069962C22.372986,8.5069962 24.742004,10.224998 24.742004,11.004997 24.742004,11.784996 22.372986,11.004997 20.994995,11.004997 19.617004,11.004997 18.497009,11.882996 18.497009,11.004997 18.497009,10.126999 19.617004,8.5069962 20.994995,8.5069962z M11.005005,8.5069962C12.382996,8.5069962 13.502991,10.126999 13.502991,11.004997 13.502991,11.882996 12.382996,11.004997 11.005005,11.004997 9.6269531,11.004997 7.2589722,11.784996 7.2589722,11.004997 7.2589722,10.224998 9.6269531,8.5069962 11.005005,8.5069962z M16,2.4970016C8.5549927,2.4970016 2.4970093,8.5550003 2.4970093,16 2.4970093,23.445 8.5549927,29.502998 16,29.502998 23.445007,29.502998 29.502991,23.445 29.502991,16 29.502991,8.5550003 23.445007,2.4970016 16,2.4970016z M16,0C24.836975,0 32,7.163002 32,16 32,24.836998 24.836975,32 16,32 7.1629639,32 0,24.836998 0,16 0,7.163002 7.1629639,0 16,0z";
        case moodsNames.moodConfused:
            return "M19.222739,17.204024C22.248786,17.204024 24.123814,18.536015 24.66783,19.867014 23.699797,19.322016 22.459788,18.868015 19.585782,19.020014 16.75273,19.170016 13.655636,19.928019 11.295615,21.622015 12.936631,18.783016 16.081698,17.204024 19.222739,17.204024z M8.0405595,12.48403C8.1116053,12.48403 8.1815535,12.490027 8.2515618,12.499029 8.8195636,12.58103 9.2866112,12.971029 9.5266053,13.567028 9.8856198,14.443027 9.5026185,15.333024 8.6175954,15.681024 8.3486087,15.78602 8.074557,15.817024 7.8045942,15.779023 7.2275588,15.696023 6.7505619,15.307023 6.5165493,14.735026 6.333563,14.295024 6.3325254,13.832028 6.5075771,13.431028 6.6735341,13.059026 6.9905559,12.764029 7.3975445,12.604025 7.6135513,12.521025 7.8285815,12.481024 8.0405595,12.48403z M22.262763,7.3220365C23.637784,7.3220365 24.753829,8.4370319 24.753829,9.8130295 24.753829,11.189027 23.637784,12.304031 22.262763,12.304031 20.888779,12.304031 19.771758,11.189027 19.771758,9.8130295 19.771758,8.4370319 20.888779,7.3220365 22.262763,7.3220365z M13.543635,7.3220365C14.917679,7.3220365 16.034701,8.4370319 16.034701,9.8130295 16.034701,11.189027 14.917679,12.304031 13.543635,12.304031 12.169652,12.304031 11.05263,11.189027 11.05263,9.8130295 11.05263,8.4370319 12.169652,7.3220365 13.543635,7.3220365z M16.034701,0.081051263C24.834824,0.081051054 31.994969,7.2410352 31.994969,16.041023 31.994969,24.841004 24.834824,31.999996 16.034701,31.999996 7.2345783,31.999996 0.075471385,24.841004 0.075471564,16.041023 0.075471385,14.048023 0.43845303,12.105025 1.1554442,10.262034 1.4034948,9.6210358 2.1254906,9.30003 2.7674684,9.5520355 3.4085304,9.8020355 3.7265286,10.523028 3.4775011,11.165033 2.8734881,12.718031 2.5664765,14.359027 2.5664767,16.041023 2.5664765,23.467007 8.6085612,29.508995 16.034701,29.508995 23.460841,29.508995 29.502927,23.467007 29.502927,16.041023 29.502927,8.6150333 23.460841,2.5730435 16.034701,2.5730435 14.426644,2.5730435 12.853622,2.8540415 11.358604,3.4060425 10.712598,3.6470394 9.9965836,3.3160462 9.7576272,2.6700437 9.5195862,2.0260474 9.8486315,1.3090459 10.493601,1.0710471 12.266637,0.41305124 14.13068,0.081051054 16.034701,0.081051263z M4.645549,4.9992161E-05C4.8375074,-0.0009495407 5.0265362,0.013050375 5.2115366,0.041050355 6.4285356,0.22604746 7.4025494,1.0210443 7.8815605,2.2260444 8.4636008,3.7020397 8.0835902,5.0860397 7.5305421,6.7410361 7.0855891,8.0610334 7.0925471,9.0470316 7.5465948,10.031032L7.7935468,10.530031C7.8325488,10.606028 7.8375537,10.699029 7.8055708,10.778032 7.7735879,10.857034 7.709561,10.923028 7.6315567,10.951028L6.0005504,11.59903C5.9485475,11.619026 5.8945305,11.62603 5.842528,11.619026 5.7445647,11.604027 5.6605183,11.541031 5.6125437,11.448029L5.3595492,10.940034C4.7235533,9.7370331 4.6715504,8.2420332 5.203541,6.60904 5.6725423,5.2400391 5.8765251,4.2810409 5.5375306,3.4200425 5.3045556,2.8380427 4.9255215,2.505043 4.3995125,2.4280474 4.0705277,2.3790438 3.6855122,2.4340438 3.2655229,2.5910413 2.5864963,2.858047 1.9134514,3.3970398 1.5824528,3.9340415 1.5335017,4.016042 1.4484784,4.0690434 1.3494778,4.0790455 1.3254906,4.0840427 1.3004659,4.0820438 1.2764788,4.0760395 1.204456,4.0670445 1.1394526,4.0350391 1.0934926,3.9840445L0.081453009,2.8760445C-0.015533429,2.7700419 -0.025543349,2.6170423 0.049470114,2.5020449 0.59348474,1.6610426 1.6824907,0.82905092 2.8234996,0.38404452 3.4574813,0.13004695 4.0685136,0.0020488065 4.645549,4.9992161E-05z";
        case moodsNames.moodCool:
            return "M24.520509,18.944002C23.292482,22.722003 20.359498,24.207004 16.000489,24.207004 13.500489,24.207004 11.302491,23.979999 11.302491,22.307002 11.302491,20.883998 13.519471,22.038005 16.000489,22.038005 19.770509,22.038005 22.216493,22.210002 24.520509,18.944002z M15.960511,13.191003C15.576478,13.191003,15.208497,13.244996,14.866456,13.342996L14.768495,13.374002 14.76349,13.642C14.62848,17.028001 12.43451,18.100999 10.462464,18.100999 8.8074962,18.100999 6.1854869,17.390001 5.2604991,14.583002L5.2304698,14.483003 5.1254894,14.474C4.456483,14.415002,3.7105114,14.309999,2.9744882,14.129999L2.7984628,14.086 2.7614755,14.409997C2.7164928,14.856996 2.692506,15.31 2.692506,15.768999 2.692506,23.106998 8.6624767,29.076 16.000489,29.076 23.338502,29.076 29.308473,23.106998 29.308473,15.768999 29.308473,15.31 29.284486,14.856996 29.239503,14.409997L29.202516,14.086 29.02649,14.129999C28.290467,14.309999,27.543458,14.415002,26.874513,14.474L26.772462,14.483003 26.74048,14.583002C25.815492,17.390001 23.193483,18.100999 21.538514,18.100999 19.566468,18.100999 17.372499,17.028001 17.237489,13.642L17.233461,13.400003 17.199464,13.388002C16.818483,13.261003,16.399476,13.191003,15.960511,13.191003z M16.000489,2.4619981C10.153505,2.4619984,5.1745006,6.2519997,3.393495,11.504999L3.3355116,11.683 3.581483,11.747003C3.9624645,11.837999,4.3615123,11.906,4.7544567,11.957002L4.9384777,11.977998 4.942506,11.932001C5.074464,10.888002 5.9884655,10.845003 10.462464,10.845003 12.029481,10.845003 13.106507,10.950998 13.791505,11.310998L13.892457,11.368997 14.116456,11.291002C14.692506,11.106996 15.313478,11.005998 15.960511,11.005998 16.700502,11.005998 17.406495,11.138002 18.048463,11.375001L18.078492,11.387002 18.085511,11.381997C18.761476,10.964998 19.873475,10.845003 21.538514,10.845003 26.012513,10.845003 26.926515,10.888002 27.058473,11.932001L27.062501,11.976999 27.246461,11.956003C27.639466,11.905,28.038514,11.836999,28.419496,11.747003L28.665467,11.682001 28.607484,11.504999C26.826478,6.2519997,21.847474,2.4619984,16.000489,2.4619981z M16.000489,0C22.940492,-2.2529207E-08,28.833497,4.4830021,30.941468,10.711L30.998475,10.889001 31.102479,10.913003C31.36847,10.988 31.610475,11.152002 31.780458,11.395997 32.143495,11.919999 32.044496,12.627 31.570497,13.031999L31.5365,13.058 31.588502,13.366998C31.70746,14.150003 31.769471,14.951997 31.769471,15.768999 31.769471,24.478 24.709474,31.536998 16.000489,31.536998 7.291505,31.536998 0.23150744,24.478 0.23150765,15.768999 0.23150744,14.951997 0.29345813,14.150003 0.41247683,13.366998L0.46447875,13.058999 0.42950564,13.031999C-0.044493533,12.627 -0.14349256,11.919999 0.21948373,11.395997 0.38848987,11.152002 0.63049426,10.988 0.89550891,10.913003L1.0025035,10.888002 1.0595103,10.711C3.1674816,4.4830021,9.0604869,-2.2529207E-08,16.000489,0z";
        case moodsNames.moodCheeky:
            return "M7.4239998,19.851C7.4239998,19.851 11.659,19.883 16,19.883 20.341,19.883 24.576,19.851 24.576,19.851 24.576,19.851 23.648,20.551 21.831,21.164L21.678,21.214 21.703,21.263C21.777,21.41 21.844,21.573 21.904,21.754 22.651,24.029 21.316,27.174 18.638,27.174 15.03,27.174 15.42,24.264 14.862,22.072L14.85,22.027 14.587,22.01C10.198,21.669,7.4239998,19.851,7.4239998,19.851z M20.995,11.005C22.373,11.005 23.493,12.123 23.493,13.503 23.493,14.882 22.373,16 20.995,16 19.617,16 18.497,14.882 18.497,13.503 18.497,12.123 19.617,11.005 20.995,11.005z M11.005,11.005C12.383,11.005 13.503,12.123 13.503,13.503 13.503,14.882 12.383,16 11.005,16 9.6269999,16 8.507,14.882 8.507,13.503 8.507,12.123 9.6269999,11.005 11.005,11.005z M16,2.4969997C8.5550003,2.4969997 2.4969997,8.5550003 2.4969997,16 2.4969997,23.445 8.5550003,29.503 16,29.503 23.445,29.503 29.503,23.445 29.503,16 29.503,8.5550003 23.445,2.4969997 16,2.4969997z M16,0C24.837,0 32,7.1630001 32,16 32,24.837 24.837,32 16,32 7.1630001,32 0,24.837 0,16 0,7.1630001 7.1630001,0 16,0z";
        case moodsNames.moodLough:
            return "M7.4559937,18.497009C7.4559937,18.497009 10.204987,19.944 16,19.944 21.794983,19.944 24.543976,18.497009 24.543976,18.497009 24.543976,22.527008 21.667999,27.041992 16,27.041992 10.332001,27.041992 7.4559937,22.527008 7.4559937,18.497009z M20.994995,11.005005C22.372986,11.005005 24.741974,12.721985 24.741974,13.502014 24.741974,14.28299 22.372986,13.502014 20.994995,13.502014 19.616974,13.502014 18.497986,14.380005 18.497986,13.502014 18.497986,12.623993 19.616974,11.005005 20.994995,11.005005z M11.004974,11.005005C12.382996,11.005005 13.502991,12.623993 13.502991,13.502014 13.502991,14.380005 12.382996,13.502014 11.004974,13.502014 9.6269836,13.502014 7.2589722,14.28299 7.2589722,13.502014 7.2589722,12.721985 9.6269836,11.005005 11.004974,11.005005z M16,2.4970093C8.5549927,2.4970093 2.4979858,8.5549927 2.4979858,16 2.4979858,23.445007 8.5549927,29.502991 16,29.502991 23.444977,29.502991 29.502991,23.445007 29.502991,16 29.502991,8.5549927 23.444977,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1629944 32,16 32,24.837006 24.836975,32 16,32 7.1629944,32 0,24.837006 0,16 0,7.1629944 7.1629944,0 16,0z";
        case moodsNames.moodCrySingle:
            return "M15.998995,16.984005C19.708003,16.984005 22.724995,19.556007 22.724995,22.717 22.724995,23.270012 22.277974,23.717005 21.724997,23.717005 21.171989,23.717005 20.724998,23.270012 20.724998,22.717 20.724998,20.658001 18.604978,18.984014 15.998995,18.984014 13.393013,18.984014 11.272991,20.658001 11.272991,22.717 11.272991,23.270012 10.826001,23.717005 10.272993,23.717005 9.7200157,23.717005 9.2729951,23.270012 9.2729953,22.717 9.2729951,19.556007 12.289987,16.984005 15.998995,16.984005z M7.964988,13.029994C7.5620358,13.963994 7.1660829,15.036992 7.1850808,15.478992 7.1910799,15.619992 7.2780696,15.818991 7.4640477,15.946991 7.7200171,16.123991 8.1059712,16.132991 8.5819147,15.972991 8.6179105,15.961991 8.6459072,15.947991 8.6729038,15.878991 8.8678808,15.385992 8.4549298,14.124993 7.964988,13.029994z M7.9269927,10.766997L8.3899376,11.625996C8.6829028,12.169996 10.116733,14.948992 9.6027935,16.247991 9.4708093,16.57999 9.2268382,16.81299 8.8988769,16.92299 8.5459191,17.03999 8.2369558,17.08699 7.9699876,17.08699 7.4840451,17.08699 7.132087,16.93199 6.8961151,16.76999 6.4781644,16.480991 6.2051969,16.002991 6.1851995,15.519992 6.1422043,14.484993 7.2730701,12.108995 7.5000432,11.643996z M19.048985,7.6669779L23.654994,7.6669779C24.207995,7.6669779 24.654996,8.1139784 24.654996,8.6669779 24.654996,9.2199779 24.207995,9.6669779 23.654994,9.6669779L19.048985,9.6669779C18.495985,9.6669779 18.048984,9.2199779 18.048984,8.6669779 18.048984,8.1139784 18.495985,7.6669779 19.048985,7.6669779z M8.032007,7.6669779L12.546997,7.6669779C13.099996,7.6669779 13.546995,8.1139784 13.546995,8.6669779 13.546995,9.2199779 13.099996,9.6669779 12.546997,9.6669779L8.032007,9.6669779C7.4800084,9.6669779 7.0320094,9.2199779 7.0320094,8.6669779 7.0320094,8.1139784 7.4800084,7.6669779 8.032007,7.6669779z M15.999985,2.000001C8.2799924,2.000001 1.9999986,8.2800007 1.9999986,16 1.9999986,23.720001 8.2799924,30.000001 15.999985,30.000001 23.719977,30.000001 29.999971,23.720001 29.999971,16 29.999971,8.2800007 23.719977,2.000001 15.999985,2.000001z M15.999985,0C24.821977,0 31.999969,7.1780005 31.999969,16 31.999969,24.822001 24.821977,32.000001 15.999985,32.000001 7.1779935,32.000001 0,24.822001 0,16 0,7.1780005 7.1779935,0 15.999985,0z";
        case moodsNames.moodVerySad:
            return "M15.999426,18.539C18.665346,18.539 21.925249,19.700975 22.335238,22.976906 22.403234,23.524893 22.015245,24.024883 21.467262,24.092882 20.917278,24.16288 20.419294,23.772888 20.350296,23.224899 20.030306,20.667953 16.669405,20.537956 15.999426,20.537956 15.343445,20.537956 12.053543,20.668955 11.642555,23.257898 11.564558,23.749889 11.13957,24.100882 10.656585,24.100882 10.604587,24.100882 10.552588,24.096882 10.49859,24.087881 9.9536057,24.001883 9.5816164,23.489895 9.6686144,22.943905 10.184599,19.691975 13.401503,18.539 15.999426,18.539z M22.041733,11.146248C22.396326,11.138357 22.744186,11.32184 22.933241,11.651853 23.20723,12.13187 23.040236,12.741894 22.560257,13.015903L18.242445,15.483995C18.086451,15.573998 17.915459,15.616 17.747467,15.616 17.399481,15.616 17.062496,15.434994 16.878504,15.111981 16.603516,14.632964 16.770508,14.021941 17.250488,13.747931L21.5683,11.279839C21.717981,11.192961,21.880552,11.149834,22.041733,11.146248z M9.7682037,11.146248C9.9295139,11.149834,10.092417,11.192961,10.242723,11.279839L14.560534,13.747931C15.040514,14.021941 15.207506,14.632964 14.932519,15.111981 14.748527,15.434994 14.411541,15.616 14.063557,15.616 13.895564,15.616 13.724571,15.573998 13.568578,15.483995L9.2507658,13.015903C8.7707863,12.741894 8.6037941,12.13187 8.8777819,11.651853 9.0661488,11.32184 9.4133205,11.138357 9.7682037,11.146248z M16,2C8.2799683,2 2,8.2799988 2,16 2,23.720001 8.2799683,30 16,30 23.719971,30 30,23.720001 30,16 30,8.2799988 23.719971,2 16,2z M16,0C24.82196,0 32,7.1779938 32,16 32,24.821991 24.82196,32 16,32 7.1779785,32 0,24.821991 0,16 0,7.1779938 7.1779785,0 16,0z";
        case moodsNames.moodSad:
            return "M16,19.85202C19.743988,19.85202 23.047974,21.71701 25.048981,24.563019 22.498993,22.729004 19.380981,21.637024 16,21.637024 12.618988,21.637024 9.5009766,22.729004 6.9509888,24.563019 8.9519958,21.71701 12.255981,19.85202 16,19.85202z M20.994995,11.005005C22.372986,11.005005 23.492981,12.123016 23.492981,13.503021 23.492981,14.882019 22.372986,16 20.994995,16 19.616974,16 18.497986,14.882019 18.497986,13.503021 18.497986,12.123016 19.616974,11.005005 20.994995,11.005005z M11.004974,11.005005C12.382996,11.005005 13.502991,12.123016 13.502991,13.503021 13.502991,14.882019 12.382996,16 11.004974,16 9.6269836,16 8.5069885,14.882019 8.5069885,13.503021 8.5069885,12.123016 9.6269836,11.005005 11.004974,11.005005z M16,2.4970093C8.5549927,2.4970093 2.4979858,8.5550232 2.4979858,16 2.4979858,23.445007 8.5549927,29.503021 16,29.503021 23.444977,29.503021 29.502991,23.445007 29.502991,16 29.502991,8.5550232 23.444977,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1629944 32,16 32,24.837006 24.836975,32 16,32 7.1629944,32 0,24.837006 0,16 0,7.1629944 7.1629944,0 16,0z";
        case moodsNames.moodAngel:
            return "M6.951001,19.850998C9.5010031,21.685997 12.618997,22.778 15.999992,22.778 19.380987,22.778 22.498998,21.685997 25.048984,19.850998 23.047993,22.696999 19.743994,24.561996 15.999992,24.561996 12.255991,24.561996 8.9519918,22.696999 6.951001,19.850998z M20.994985,11.004997C22.372991,11.004997 23.492985,12.123001 23.492985,13.502998 23.492985,14.881996 22.372991,16 20.994985,16 19.616995,16 18.496986,14.881996 18.496986,13.502998 18.496986,12.123001 19.616995,11.004997 20.994985,11.004997z M11.005,11.004997C12.38299,11.004997 13.503,12.123001 13.503,13.502998 13.503,14.881996 12.38299,16 11.005,16 9.6269949,16 8.5069998,14.881996 8.5069998,13.502998 8.5069998,12.123001 9.6269949,11.004997 11.005,11.004997z M5.2299936,7.8659973L5.1829966,7.9259949C3.4969926,10.18 2.4969931,12.974998 2.4969931,16 2.4969931,23.445 8.5550039,29.502998 15.999992,29.502998 23.444996,29.502998 29.501985,23.445 29.501985,16 29.501985,12.974998 28.502992,10.18 26.815983,7.9259949L26.769993,7.8659973 26.586994,7.913002C22.740988,8.862999 17.521995,8.9369965 15.999992,8.9369965 14.47799,8.9369965 9.2589987,8.862999 5.4129918,7.913002z M27.150987,4.5270004L27.313982,4.685997C27.403993,4.7770004,27.49399,4.8679962,27.581987,4.9609985L27.625994,5.0079956 27.744982,4.961998C27.85399,4.9179993 27.952989,4.875 28.041994,4.8320007 27.845995,4.7480011 27.578981,4.651001 27.217989,4.5459976z M4.8489969,4.5270004L4.7810038,4.5469971C4.4210031,4.651001 4.1549972,4.7480011 3.9589982,4.8320007 4.0469954,4.875 4.1459945,4.9179993 4.2559951,4.961998L4.3740061,5.0079956 4.4179972,4.9609985C4.5059946,4.8679962,4.5960062,4.7770004,4.6860025,4.685997z M15.999992,2.4970016C12.74299,2.4970016,9.7510031,3.6569977,7.4159968,5.5849991L7.2259949,5.7460022 7.3439906,5.7679977C9.4379995,6.1449966 12.341989,6.4389954 15.999992,6.4389954 19.657995,6.4389954 22.561987,6.1449966 24.655994,5.7679977L24.77399,5.7460022 24.583988,5.5849991C22.248998,3.6569977,19.256994,2.4970016,15.999992,2.4970016z M15.999992,0C18.070991,0,20.049993,0.39299774,21.866995,1.1100006L22.118994,1.2129974 22.233999,1.1959991C22.315985,1.1879959 22.400991,1.1869965 22.485998,1.1949997 28.578981,1.8689957 30.951996,2.8779984 30.951996,4.7979965 30.951996,5.6589966 30.355989,6.3419952 29.398989,6.8829956L29.216982,6.9809952 29.267,7.0540009C30.992981,9.6080017 32,12.685997 32,16 32,24.836998 24.836994,32 15.999992,32 7.1629913,32 1.9745858E-07,24.836998 0,16 1.9745858E-07,12.685997 1.0070035,9.6080017 2.7330008,7.0540009L2.7830038,6.9809952 2.600997,6.8829956C1.6439966,6.3419952 1.0480038,5.6589966 1.0480037,4.7979965 1.0480038,2.8799973 3.4179979,1.8720016 9.499996,1.1969986 9.5859945,1.1879959 9.6710012,1.1889954 9.7539938,1.1969986L9.8760021,1.2149963 10.132991,1.1100006C11.949991,0.39299774,13.928994,0,15.999992,0z";
        case moodsNames.moodAngry:
            return "M13.502991,22.031998L13.502991,23.406998 13.661987,23.463997C14.394989,23.709999,15.197998,23.874001,16,23.874001L16,22.175995C15.185974,22.175995,14.337982,22.102997,13.517975,22.032997z M19.745972,21.907997L19.664978,21.914001C19.313995,21.940002 18.944,21.974998 18.562988,22.012001 18.140991,22.052002 17.710999,22.093002 17.280975,22.124001L17.248993,22.125999 17.248993,23.755997 17.442993,23.716995C18.280975,23.541,19.064972,23.235001,19.710999,22.896996L19.745972,22.877998z M11.449982,21.906998C11.233978,21.906998 11.059998,21.916 10.918976,21.928001 11.192993,22.195999 11.625977,22.510002 12.163971,22.806999L12.253998,22.854996 12.253998,21.934998 12.174988,21.93C11.92099,21.916,11.678986,21.906998,11.449982,21.906998z M20.994995,21.879997L20.994995,22.038002 21.029999,22.005997C21.071991,21.965996 21.110992,21.928001 21.145996,21.889999 21.113983,21.887001 21.079987,21.885002 21.042999,21.881996z M20.651001,19.873001C22.190979,19.873001 23.345001,20.233002 23.345001,21.736 23.345001,23.572998 19.422974,25.871002 16,25.871002 12.576996,25.871002 8.6549988,23.503998 8.6549988,21.736 8.6549988,20.255997 9.8589783,19.908997 11.449982,19.908997 12.850983,19.908997 14.552979,20.178001 16,20.178001 17.481995,20.178001 19.22998,19.873001 20.651001,19.873001z M23.339996,11.069C24.470978,11.029999 24.845001,13.196999 24.496979,14.499001 24.095978,16 22.85199,17.249001 21.302979,17.249001 19.294983,17.249001 17.990997,14.656998 19.139984,13.816002 20.526978,12.799995 21.71698,11.960999 22.633972,11.336998 22.895996,11.158997 23.130981,11.075996 23.339996,11.069z M8.6599731,11.069C8.868988,11.075996 9.1049805,11.158997 9.3659973,11.336998 10.28299,11.960999 11.472992,12.799995 12.859985,13.816002 14.008972,14.656998 12.704987,17.249001 10.696991,17.249001 9.1479797,17.249001 7.9039917,16 7.5029907,14.499001 7.1549988,13.196999 7.5289917,11.029999 8.6599731,11.069z M23.454987,6.8850021C23.47998,6.8839951 23.503998,6.8839951 23.527985,6.8850021 23.890991,6.8969955 24.232971,7.1080017 24.39798,7.4580002 24.631989,7.9570007 24.416992,8.5530014 23.916992,8.7859955 20.733978,10.282997 19.200989,11.714996 19.184998,11.728996 18.992981,11.911995 18.744995,12.002998 18.496979,12.002998 18.233978,12.002998 17.970978,11.897995 17.773987,11.693001 17.394989,11.293999 17.408997,10.663002 17.806976,10.282997 17.876984,10.215996 19.557983,8.6269989 23.067993,6.9789963 23.194,6.9199982 23.324982,6.8899994 23.454987,6.8850021z M8.4989929,6.8839951C8.6279907,6.8819962 8.7609863,6.9069977 8.8880005,6.9589996 12.559998,8.4720001 14.181976,10.265999 14.248993,10.340996 14.615997,10.753998 14.577972,11.383995 14.165985,11.750999 13.975983,11.920998 13.738983,12.003998 13.502991,12.003998 13.22699,12.003998 12.953979,11.889999 12.755981,11.667999 12.745972,11.657997 11.332977,10.127998 8.1269836,8.8059998 7.6169739,8.5960007 7.3729858,8.012001 7.5829773,7.5019989 7.7409973,7.1199951 8.1089783,6.887001 8.4989929,6.8839951z M16,2.4970016C8.5549927,2.4970016 2.4969788,8.5550003 2.4969788,16 2.4969788,23.445 8.5549927,29.502998 16,29.502998 23.444977,29.502998 29.502991,23.445 29.502991,16 29.502991,8.5550003 23.444977,2.4970016 16,2.4970016z M16,0C24.836975,0 32,7.163002 32,16 32,24.836998 24.836975,32 16,32 7.1629944,32 0,24.836998 0,16 0,7.163002 7.1629944,0 16,0z";
        case moodsNames.moodWink:
            return "M24.609009,17.390015C23.666016,20.937012 20.515991,24.563019 15.980957,24.563019 12.375977,24.563019 10.297974,23.042023 8.8079834,21.083008 10.382996,22.063019 12.726013,22.447021 15.980957,22.447021 19.281982,22.447021 22.505005,20.112 24.609009,17.390015z M21.003967,12.292999C22.622009,12.292999 24.643982,13.718018 24.643982,14.477997 24.643982,14.809998 21.860962,14.723022 20.242981,14.723022 18.622986,14.723022 17.307983,14.732025 17.307983,14.244019 17.307983,13.389008 19.383972,12.292999 21.003967,12.292999z M11.005005,11.005005C12.382996,11.005005 13.502991,12.123016 13.502991,13.503021 13.502991,14.882019 12.382996,16 11.005005,16 9.6270142,16 8.506958,14.882019 8.506958,13.503021 8.506958,12.123016 9.6270142,11.005005 11.005005,11.005005z M16,2.4970093C8.5549927,2.4970093 2.4970093,8.5550232 2.4970093,16 2.4970093,23.445007 8.5549927,29.503021 16,29.503021 23.445007,29.503021 29.502014,23.445007 29.502014,16 29.502014,8.5550232 23.445007,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1630249 32,16 32,24.837006 24.836975,32 16,32 7.1629639,32 0,24.837006 0,16 0,7.1630249 7.1629639,0 16,0z";
        case moodsNames.moodLove:
            return "M6.9509888,19.851013C9.5009766,21.686005 12.618958,22.777985 16,22.777985 19.380981,22.777985 22.498962,21.686005 25.04895,19.851013 23.047974,22.696991 19.743958,24.562012 16,24.562012 12.255981,24.562012 8.9519653,22.696991 6.9509888,19.851013z M23.704956,11.042999C24.990967,11.036011 25.904968,11.880005 25.911987,13.221985 25.92395,15.466003 23.200989,16.601013 21.67395,18.428009L21.651978,18.428986C20.102966,16.618011 17.369995,15.514008 17.357971,13.27301 17.348999,11.93399 18.247009,11.074005 19.539001,11.066986 20.67395,11.061005 21.626953,12.36499 21.626953,12.36499 21.626953,12.36499 22.565979,11.049988 23.704956,11.042999z M12.466003,11.042999C13.751953,11.036011 14.665955,11.880005 14.672974,13.221985 14.684998,15.466003 11.961975,16.601013 10.434998,18.428009L10.412964,18.428986C8.8629761,16.618011 6.1300049,15.514008 6.117981,13.27301 6.1099854,11.93399 7.006958,11.074005 8.2999878,11.066986 9.4349976,11.061005 10.388,12.36499 10.388,12.36499 10.388,12.36499 11.326965,11.049988 12.466003,11.042999z M16,2.4970093C8.5549927,2.4970093 2.4979858,8.5549927 2.4979858,16 2.4979858,23.445007 8.5549927,29.502991 16,29.502991 23.445007,29.502991 29.502991,23.445007 29.502991,16 29.502991,8.5549927 23.445007,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1629944 32,16 32,24.837006 24.836975,32 16,32 7.1629639,32 0,24.837006 0,16 0,7.1629944 7.1629639,0 16,0z";
        case moodsNames.moodDevil:
            return "M13.518005,22.008001L13.518005,23.375005 13.677002,23.431997C14.404999,23.676,15.203003,23.839009,16,23.839009L16,22.151006C15.190002,22.151006,14.348007,22.079,13.533997,22.009008z M19.723999,21.886007L19.641998,21.891011C19.294006,21.916997 18.925995,21.952001 18.548004,21.989003 18.128006,22.028997 17.699997,22.069005 17.272995,22.100011L17.240997,22.10201 17.240997,23.720998 17.434006,23.683004C18.266998,23.508001,19.046997,23.204,19.688004,22.868001L19.723999,22.849004z M11.477997,21.884999C11.263,21.884999 11.089996,21.89301 10.951004,21.905004 11.223007,22.172002 11.653,22.483998 12.186996,22.778997L12.277008,22.827001 12.277008,21.912007 12.197998,21.907003C11.945999,21.89301,11.705002,21.884999,11.477997,21.884999z M20.964996,21.858007L20.964996,22.015004 20.999008,21.983007C21.041,21.944005 21.080002,21.905004 21.115005,21.868001 21.083008,21.86501 21.048004,21.862004 21.012009,21.860006z M20.623001,19.862004C22.153,19.862004 23.300003,20.220998 23.300003,21.714009 23.300003,23.539998 19.402008,25.825004 16,25.825004 12.598007,25.825004 8.6999969,23.470998 8.6999969,21.714009 8.6999969,20.243001 9.8959961,19.899007 11.477997,19.899007 12.871002,19.899007 14.563004,20.166005 16,20.166005 17.473007,20.166005 19.210999,19.862004 20.623001,19.862004z M24.331009,11.141009C24.496994,11.141009 24.591995,11.143007 24.591995,11.143007 24.591995,11.143007 24.695007,15.052997 23.589996,16.159 22.481003,17.267001 18.565994,17.164996 18.574005,17.162006 18.582001,17.160999 18.468994,13.254001 19.576004,12.147006 20.509995,11.212008 23.438995,11.140001 24.331009,11.141009z M7.6690063,11.141009C8.5610046,11.140001 11.490005,11.212008 12.423996,12.147006 13.531006,13.254001 13.417999,17.160999 13.425995,17.162006 13.434006,17.164996 9.5189972,17.267001 8.4100037,16.159 7.3050079,15.052997 7.4080048,11.143007 7.4080048,11.143007 7.4080048,11.143007 7.503006,11.141009 7.6690063,11.141009z M16,2.5939945C8.6009979,2.5939945 2.5810089,8.6140005 2.5810089,16.013995 2.5810089,23.412999 8.6009979,29.433005 16,29.433005 23.399002,29.433005 29.419006,23.412999 29.419006,16.013995 29.419006,8.6140005 23.399002,2.5939945 16,2.5939945z M0,0C1.7140045,2.2400059,4.2100067,3.4149939,5.4790039,3.8990029L5.6320038,3.9559945 5.8849945,3.7420048C8.6340027,1.4739992 12.158005,0.1109923 16,0.11099243 19.841995,0.1109923 23.365997,1.4739992 26.115005,3.7420048L26.367996,3.9559945 26.520996,3.8990029C27.790009,3.4149939 30.285995,2.2400059 32,0 31.977997,3.9190072 30.115005,6.4960038 29.417007,7.3249985L29.361008,7.3889939 29.395996,7.4420029C30.981995,9.9160024 31.902008,12.856998 31.902008,16.013995 31.902008,24.79601 24.781998,31.915 16,31.915 7.2180023,31.915 0.098007202,24.79601 0.098007202,16.013995 0.098007202,12.856998 1.0180054,9.9160024 2.6040039,7.4420029L2.6390076,7.3889939 2.5830078,7.3249985C1.8849945,6.4960038,0.022003174,3.9190072,0,0z";
        case moodsNames.moodWorried:
            return "M21.07196,17.211029C21.862,17.220001 22.511963,17.721008 22.944946,18.093018 23.367981,18.460022 23.767944,18.906006 24.165955,19.458008L24.348999,19.623016 24.343994,19.642029C24.36499,19.667023 24.386963,19.69101 24.407959,19.716003 24.805969,20.185028 25.11499,20.763 25.355957,21.480011 25.424988,21.675018 25.398987,21.884003 25.281982,22.048004 25.158997,22.221008 24.952942,22.324005 24.730957,22.324005 24.441956,22.324005 24.195984,22.14801 24.103943,21.876007 23.909973,21.314026 23.67395,20.878021 23.384949,20.542023L23.303955,20.457001C23.230957,20.384003 23.159973,20.309021 23.097961,20.22403 22.824951,19.837006 22.475952,19.443024 22.112,19.114014 21.577942,18.631012 21.174988,18.449005 20.849976,18.567017 20.605957,18.651001 20.405945,19.063019 20.329956,19.218018 20.223999,19.442017 20.125977,19.662018 20.112,19.867004 20.069946,20.488007 19.987976,21.090027 19.868958,21.654022 19.715942,22.361023 19.485962,23.155029 18.928955,23.696014 18.372986,24.242004 17.388977,24.245026 16.789001,23.712006 16.419983,23.380005 16.03595,23.082001 15.643982,22.828003 15.454956,22.707001 15.237,22.574005 15.014954,22.495026 15.019958,22.626007 15.054993,22.77301 15.093994,22.926025 15.116943,23.018005 15.136963,23.107025 15.154968,23.195007 15.418945,24.626007 14.931946,25.654022 13.882996,25.880005 13.720947,25.913025 13.549988,25.93103 13.373962,25.93103 12.567993,25.93103 11.782959,25.578003 11.047974,25.215027 10.768982,25.07901 10.510986,24.916016 10.252991,24.751007 10.083984,24.644012 9.914978,24.535004 9.7369995,24.436005 9.5549927,24.335022 9.072998,24.160004 9.0619507,24.157013 9.0619507,24.157013 7.6429443,23.416016 8.4319458,22.944 8.9909668,22.610016 9.7729492,22.951019 10.386963,23.289001 10.587952,23.400024 10.777954,23.521027 10.967957,23.643005 11.194946,23.787018 11.419983,23.93103 11.664978,24.053009 12.219971,24.32901 13.155945,24.757019 13.702942,24.565002 13.829956,24.52002 13.898987,24.279022 13.911987,24.059021 13.928955,23.754028 13.901978,23.583008 13.817993,23.257019 13.72998,22.909027 13.465942,21.856018 14.213989,21.31601 14.392944,21.186005 14.606995,21.117004 14.849976,21.117004 15.408997,21.117004 15.985962,21.486023 16.329956,21.705017 16.770996,21.98703 17.20697,22.323029 17.672974,22.734009 17.685974,22.742004 17.714966,22.754028 17.748962,22.772003 17.820984,22.805023 17.858948,22.814026 17.899963,22.814026 17.958984,22.803009 18.052979,22.731018 18.147949,22.585022 18.46698,22.096008 18.590942,21.430023 18.690002,20.789001 18.754944,20.363007 18.790955,20.009003 18.803955,19.676025 18.81897,19.36203 18.959961,19.053009 19.073975,18.804016L19.129944,18.68103C19.238953,18.434021 19.383972,18.193024 19.575989,17.947021 19.879944,17.563019 20.286987,17.314026 20.724976,17.238007 20.843994,17.218018 20.959961,17.209015 21.07196,17.211029z M20.994995,7.2580261C22.372986,7.2580261 23.492981,8.9360046 23.492981,11.005005 23.492981,13.074005 22.372986,14.751007 20.994995,14.751007 19.616943,14.751007 18.497986,13.074005 18.497986,11.005005 18.497986,8.9360046 19.616943,7.2580261 20.994995,7.2580261z M11.003967,7.2580261C12.382996,7.2580261 13.502991,8.9360046 13.502991,11.005005 13.502991,13.074005 12.382996,14.751007 11.003967,14.751007 9.6269531,14.751007 8.506958,13.074005 8.506958,11.005005 8.506958,8.9360046 9.6269531,7.2580261 11.003967,7.2580261z M16,2.4970093C8.5549927,2.4970093 2.4979858,8.5550232 2.4979858,16 2.4979858,23.445007 8.5549927,29.503021 16,29.503021 23.444946,29.503021 29.502991,23.445007 29.502991,16 29.502991,8.5550232 23.444946,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1630249 32,16 32,24.837006 24.836975,32 16,32 7.1629639,32 0,24.837006 0,16 0,7.1630249 7.1629639,0 16,0z";
        case moodsNames.moodSpeechless:
            return "M9.6279907,16.861023L16.10498,20.067017 22.948975,17.756012 23.867981,20.475006 19.743958,21.868011 23.645996,23.800018 22.369995,26.373016 15.895996,23.167999 9.0489502,25.480011 8.131958,22.759003 12.256958,21.365997 8.3549805,19.434021z M20.994995,9.756012C22.372986,9.756012 23.492981,10.874023 23.492981,12.253998 23.492981,13.632996 22.372986,14.751007 20.994995,14.751007 19.617004,14.751007 18.497009,13.632996 18.497009,12.253998 18.497009,10.874023 19.617004,9.756012 20.994995,9.756012z M11.005005,9.756012C12.382996,9.756012 13.502991,10.874023 13.502991,12.253998 13.502991,13.632996 12.382996,14.751007 11.005005,14.751007 9.6269531,14.751007 8.506958,13.632996 8.506958,12.253998 8.506958,10.874023 9.6269531,9.756012 11.005005,9.756012z M16,2.4970093C8.5549927,2.4970093 2.4970093,8.5550232 2.4970093,16 2.4970093,23.445007 8.5549927,29.503021 16,29.503021 23.445007,29.503021 29.501953,23.445007 29.501953,16 29.501953,8.5550232 23.445007,2.4970093 16,2.4970093z M16,0C24.836975,0 32,7.1629944 32,16 32,24.837006 24.836975,32 16,32 7.1629639,32 0,24.837006 0,16 0,7.1629944 7.1629639,0 16,0z";
        default:
            return "";
    }
}

export const moodsNames = {
    moodSurprised: "MoodSurprised",
    moodKiss: "MoodKiss",
    moodSmile: "MoodSmile",
    moodSleepy: "MoodSleepy",
    moodCry: "MoodCry",
    moodConfused: "MoodConfused",
    moodCool: "MoodCool",
    moodCheeky: "MoodCheeky",
    moodLough: "MoodLough",
    moodCrySingle: "MoodCrySingle",
    moodVerySad: "MoodVerySad",
    moodSad: "MoodSad",
    moodAngel: "MoodAngel",
    moodAngry: "MoodAngry",
    moodWink: "MoodWink",
    moodLove: "MoodLove",
    moodDevil: "MoodDevil",
    moodWorried: "MoodWorried",
    moodSpeechless: "MoodSpeechless"
}